<table class="table is-fullwidth is-striped is-hoverable">
  <thead>
    <tr>
      @for (column of columnsHeader; track $index) {
        <th [class.has-text-centered]="column.isCentered">
          @if (column.type === 'checkbox') {
            <label class="checkbox select-all-label">
              <input
                type="checkbox"
                [ngModel]="allSelected"
                [indeterminate]="someSelected"
                (ngModelChange)="toggleAll($event)"
                aria-label="Seleccionar todas las órdenes"
              />
            </label>
          } @else {
            <span>{{ column.title }}</span>
          }
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of rows; track $index; let i = $index) {
      <tr [class.has-apo-errors]="row.template === false" [class.type-new]="row.tipo === 'new'">
        @for (column of columnsHeader; track $index) {
          <td [class.has-text-centered]="column.isCentered"
              [class.is-editable]="isCellEditable(row, column)"
              [class.is-editing]="isEditing(i, column.key)"
              (click)="startEdit(i, column, $event)">

            @if (column.type === 'checkbox') {
              <!-- to_plan toggle -->
              <label class="checkbox" (click)="$event.stopPropagation()">
                <input
                  type="checkbox"
                  [(ngModel)]="row.to_plan"
                  (ngModelChange)="onCheckboxChange()"
                  [attr.aria-label]="'Planificar orden ' + (row.name ?? '')"
                />
              </label>

            } @else if (isCellEditable(row, column) && isEditing(i, column.key)) {
              <!-- inline editor -->
              @if (column.editType === 'select') {
                <select
                  #editInput
                  class="select-inline"
                  [(ngModel)]="editingValue"
                  (blur)="commitEdit(column)"
                  (keydown)="onKeydown($event, column)"
                  (click)="$event.stopPropagation()"
                  [attr.aria-label]="'Editar ' + column.title"
                >
                  <option value="">-- Sin asignar --</option>
                  @for (opt of getOptions(column); track opt.id) {
                    <option [value]="opt.id">{{ opt.description }}</option>
                  }
                </select>

              } @else if (column.editType === 'date') {
                <input
                  #editInput
                  type="date"
                  class="input-inline"
                  [(ngModel)]="editingValue"
                  (blur)="commitEdit(column)"
                  (keydown)="onKeydown($event, column)"
                  (click)="$event.stopPropagation()"
                  [attr.aria-label]="'Editar ' + column.title"
                />

              } @else if (column.editType === 'number') {
                <input
                  #editInput
                  type="number"
                  class="input-inline"
                  [(ngModel)]="editingValue"
                  (blur)="commitEdit(column)"
                  (keydown)="onKeydown($event, column)"
                  (click)="$event.stopPropagation()"
                  [attr.aria-label]="'Editar ' + column.title"
                />

              } @else {
                <input
                  #editInput
                  type="text"
                  class="input-inline"
                  [(ngModel)]="editingValue"
                  (blur)="commitEdit(column)"
                  (keydown)="onKeydown($event, column)"
                  (click)="$event.stopPropagation()"
                  [attr.aria-label]="'Editar ' + column.title"
                />
              }

            } @else {
              <!-- display value -->
              <span [class.editable-hint]="isCellEditable(row, column)">
                {{ getDisplayValue(row, column) }}
                @if (isCellEditable(row, column) && !getDisplayValue(row, column)) {
                  <span class="placeholder-hint">—</span>
                }
              </span>
            }

          </td>
        }
      </tr>
    } @empty {
      <tr>
        <td class="has-text-centered" [attr.colspan]="columnsHeader.length">No hay datos</td>
      </tr>
    }
  </tbody>
</table>
